import { useQuery } from "@tanstack/react-query";
import type { FC } from "react";
import { Api } from "../../api.config";
import { useCompany } from "../../company/useCompany";
import { Select } from "../../components/Select";
import { QueryKeys } from "../../LinkGen";

export const PixelSelectField: FC<{
	id: string;
	value: string;
	onChange: (pixelId: string) => void;
}> = ({ id, value, onChange }) => {
	const company = useCompany();
	const { data: pixels = [], isLoading } = useQuery({
		queryKey: QueryKeys.Integrations.MetaAds.Pixels(company.id),
		queryFn: () => Api.GetMetaAdsPixels().then((r) => r.data),
	});

	if (isLoading) {
		return (
			<input
				id={id}
				type="text"
				className="form-control"
				value={value}
				onChange={(e) => onChange(e.target.value)}
				placeholder="Loading pixels..."
				disabled
			/>
		);
	}

	if (pixels.length === 0) {
		return (
			<input
				id={id}
				type="text"
				className="form-control"
				value={value}
				onChange={(e) => onChange(e.target.value)}
				placeholder="Enter your Meta Pixel ID"
			/>
		);
	}

	return (
		<Select
			id={id}
			className="form-select"
			value={value}
			onChange={(e) => onChange(e.target.value)}
		>
			<option value="">Select a connected pixel</option>
			{pixels.map((pixel) => (
				<option key={pixel.id} value={pixel.id}>
					{pixel.name} ({pixel.id})
				</option>
			))}
		</Select>
	);
};
